import React from 'react'
import Slider from '../../components/Slider/Slider'
import FeaturedProducts from '../../components/FeaturedProducts/FeaturedProducts'
import Categories from '../../components/Categories/Categories'
import Contact from '../Contact/Contact'
import About from '../About/About'
import "./Home.scss"
import Card
    from '../../components/Card/Card'
import Wishlist from '../Wishlist/Wishlist'
import FeaturedDesc from '../../components/FeaturedProducts/FeaturedDesc'
import { Link }
    from 'react-router-dom';
import essencesList from '../../components/Essences/EssencesList'
import EssenceTypes from '../../components/Essences/EssenceTypes'
import Reviews from '../../components/Reviews/Reviews'
import ThemeToggle from "../../ThemeToggle"
import { useState, useEffect } from 'react'
import NavBar from '../../components/NavBar/NavBar'
import { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';
import { Box, Typography } from '@mui/material'
import { useIntl } from 'react-intl'

const Home = () => {
    const intl = useIntl();
    // const [mode, setMode] = useState("light");
    // const { mode, setMode } = useColorScheme();
    // 

    return (
        <Box>            <Slider type="slide" />
            <Categories />

            <FeaturedProducts type="Bestsellery" title={intl.formatMessage({ id: "section_bestsellers" })} isNew={false} />
            <EssenceTypes />

            <FeaturedProducts type="Nowe" title={intl.formatMessage({ id: "section_new" })} isNew={true} />
            <Reviews />

            {/* <NewsletterSubscription />  */}
        </Box>
    )
}
export default Home